import { render, staticRenderFns } from "./konsoloslukminiara.vue?vue&type=template&id=f86e3ce0"
import script from "./konsoloslukminiara.vue?vue&type=script&lang=js"
export * from "./konsoloslukminiara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports